import { createSelector } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
export const useIsEditMode = () => useSelector((state) => state.designer.present.active);
export const useEditedAnalysis = () => useSelector((state) => state.designer.present.analysis, isEqual);
export const useEditedAnalysisIndex = () => useSelector((state) => state.designer.present.index);
export const useEditedAnalysisName = () => useSelector((state) => state.designer.present.analysis?.name);
export const useEditedSections = () => useSelector((state) => state.designer.present.sections, isEqual);
export const selectedSectionIndexSelector = createSelector((state) => state.designer?.present?.analysis?.sections, (_, selectedSection) => selectedSection, (sections, selectedSection) => sections?.findIndex((s) => s.id === selectedSection) ?? -1);
export const widgetRequiredModulesSelector = createSelector((state) => state.entities.Widget, (widget) => Object.keys(widget).reduce((acc, key) => {
    acc[key] = widget[key].requiredModules;
    return acc;
}, {}));
